module.exports = __webpack_public_path__ + "static/media/YM37_0.a584a720.jpg";